import { combineReducers } from "redux";

import roleLevelReducer from "./roleLevelSlice.ts";
import userLevelReducer from "./userLevelSlice.ts";
import customRolesReducer from "./customRolesSlice.js";

const reportReducer = combineReducers({
    roleLevel: roleLevelReducer,
    userLevel: userLevelReducer, 
    customRoles: customRolesReducer,
});

export default reportReducer;
